module.exports = __webpack_public_path__ + "img/cancun-familia.93182997.jpg";